import React from 'react';

const MyClassroomsSkeleton = () => {
	return (
		<div aria-hidden="true">
			<div className={'my-classrooms-box'}>
				<div className={'my-classrooms-title-box skeleton'}>
					<div className={'skeleton-heading'}></div>
				</div>
				<div className={'my-classrooms-slider-box skeleton'}></div>
			</div>
			<div className={'my-classrooms-box'}>
				<div className={'my-classrooms-title-box skeleton'}>
					<div className={'skeleton-heading'}></div>
				</div>
				<div className={'my-classrooms-slider-box skeleton'}></div>
			</div>
			<div className={'my-classrooms-box'}>
				<div className={'my-classrooms-title-box skeleton'}>
					<div className={'skeleton-heading'}></div>
				</div>
				<div className={'my-classrooms-slider-box skeleton'}></div>
			</div>
		</div>
	);
};

export default MyClassroomsSkeleton;
